import React from 'react'
import styled from '@emotion/styled'
import { type GridColumn, Tooltip, Text, spacing } from '@retailer-platform/shared-components'
import { InformationIcon } from '@instacart/ids-core'
import { type StoreMetric } from 'domains/aggregate-store-performance/types/AggregateStorePerformance.types'

const NO_VALUE_INDICATOR = '–'

const Header = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

const InfoIconContainer = styled.div({
  flexShrink: 0,
  marginLeft: spacing.X4,
})

const TooltipTitle = styled.div({
  marginBottom: spacing.X8,
})

const TooltipDisclaimer = styled.div({
  marginTop: spacing.X8,
})

type HeaderTooltip = {
  title: string
  content: string
  disclaimer?: string
}

interface createBasicColumnOptions {
  id: string
  field: keyof StoreMetric
  header: string
  tooltip?: HeaderTooltip
  noValueIndicator?: string | number
}

export const createBasicColumn = ({
  id,
  field,
  header,
  tooltip,
  noValueIndicator = NO_VALUE_INDICATOR,
}: createBasicColumnOptions): GridColumn<StoreMetric> => ({
  id,
  Header: () => (
    <Header>
      {header}
      {tooltip && (
        <Tooltip
          target={
            <InfoIconContainer>
              <InformationIcon size={12} color={'systemGrayscale30'} />
            </InfoIconContainer>
          }
          placement="bottom"
        >
          <TooltipTitle>
            <Text weight={'bold'}>{tooltip.title}</Text>
          </TooltipTitle>
          <Text>{tooltip.content}</Text>
          <TooltipDisclaimer>
            <Text weight={'bold'}>{tooltip.disclaimer}</Text>
          </TooltipDisclaimer>
        </Tooltip>
      )}
    </Header>
  ),
  accessor: storeMetric => storeMetric[field],
  Cell: ({ row: { original: storeMetric } }) => storeMetric[field] ?? noValueIndicator,
  isSortable: true,
  sortType: 'basic',
})
